/* eslint-disable @typescript-eslint/naming-convention */
import { ElementRef, HostListener, Input, Renderer2, Directive, forwardRef, inject } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

const APP_FILE_INPUT_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => AppFileInputDirective),
  multi: true,
};

@Directive({
  selector: '[libFileInput][type=file]',
  providers: [APP_FILE_INPUT_ACCESSOR],
})
export class AppFileInputDirective implements ControlValueAccessor {
  private readonly _elementRef = inject<ElementRef<HTMLInputElement>>(ElementRef);
  private readonly _renderer = inject(Renderer2);

  @Input() name!: string;

  private file: File | null = null;

  @HostListener('focus')
  onFocus() {
    this.focused = true;
  }

  @HostListener('blur')
  onBlur() {
    this.focused = false;
  }

  @HostListener('change', ['$event.target.files'])
  emitFiles(files: FileList) {
    const file = files && files.item(0);
    this._onChange(file);
    this._onTouched();
    this.file = file;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public _onChange = (_: any) => {};
  public _onTouched = () => {};

  writeValue() {
    // Clear file input
    this._elementRef.nativeElement.value = '';
    this.file = null;
  }

  set focused(isFocused: boolean) {
    if (!isFocused) {
      this._onTouched();
    }
  }

  registerOnChange(fn: (value: any) => any): void {
    this._onChange = fn;
  }

  registerOnTouched(fn: () => any): void {
    this._onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
  }
}
